import React, {Component} from 'react';
import axios from 'axios';
import {connect} from 'react-redux';
import MaterialIcon from "../../../../../MaterialIcon";
import TestOptionInput from "./TestOptionInput";
import getAxiosConfig from '../../../../../../utils/axiosConfig';
import {showToastForBackend, showToastForFrontend} from '../../../../../../actions/toastActions';
import MessageCodes from '../../../../../../utils/messageCodes';
import RawPanel from "./RawPanel";

class LogicTestingPanel extends Component {

    constructor(props) {
        super(props);
        this.state = {
            requestParamsFields: [
                {
                    name: "Final Block",
                    type: "select",
                    options: ["test1", "test2"]
                },
                {
                    name: "Item Count",
                    type: "number"
                },
                {
                    name: "User Id",
                    type: "text"
                },
                {
                    name: "Cookie Id",
                    type: "text"
                }
            ],
            contextPropsFields: this.props.contextProperties,
            contextPropsValues: {},
            requestParamsValues: {},
            loadingResults: false,
            results: [],
            time: "",
            raw : "",
            noResultsFound: false,
            debugModeChecked: localStorage.getItem("debugInfo") !== null
        };

        this.onGetRecommendation = this.onGetRecommendation.bind(this);
        this.handleContextPropChange = this.handleContextPropChange.bind(this);
        this.handleRequestParamChange = this.handleRequestParamChange.bind(this);
        this.onDebugModeCheck = this.onDebugModeCheck.bind(this);
    }


    handleContextPropChange(name, value) {
        let updateParam = {};
        updateParam[name] = value;

        this.setState((prevState) => (
            {
                contextPropsValues: {
                    ...prevState.contextPropsValues,
                    ...updateParam
                }
            }
        ));
    }

    handleRequestParamChange(name, value) {
        let updateParam = {};
        let fieldName = "";
        switch (name) {
            case "Final Block":
                fieldName = "finalBlock";
                break;
            case "Item Count":
                fieldName = "numberLimit";
                break;
            case "User Id":
                fieldName = "userId";
                break;
            case "Cookie Id":
                fieldName = "cookieId";
                break;
            default:
                fieldName = "Error";

        }
        updateParam[fieldName] = value;

        this.setState((prevState) => (
            {
                requestParamsValues: {
                    ...prevState.requestParamsValues,
                    ...updateParam
                }
            }
        ));
    }

    handleGroundClick(e) {
        if (e.target.className === "test-logic-wrapper") {
            this.props.toggleLogicTestModal();
        }
    }

    onGetRecommendation() {
        const modifiedGraph = Object.assign({}, this.props.graph)

        if (modifiedGraph.nodes) {
            modifiedGraph.nodes.forEach((node) => {
                if (node.blockDescription) {
                    delete node.blockDescription;
                }
            });
        }

        let requestBody = {
            scenarioId: this.props.graph.logic.name,
            ...this.state.requestParamsValues,
            json: modifiedGraph,
            debugMode: this.state.debugModeChecked,
            keyValues: []
        };


        for (let contextProp in this.state.contextPropsValues) {
            const values = this.state.contextPropsValues[contextProp].replace("\\|", "--//--").split("|");
            for (let i = 0; i < values.length; i++) {
                const value = values[i].replace("--//--", "|");
                requestBody = {
                    ...requestBody,
                    keyValues: [
                        ...requestBody.keyValues,
                        {
                            "key": contextProp,
                            "value": value
                        }
                    ]
                };
            }
        }

        this.setState(() => ({loadingResults: true, results: []}), function () {
            axios.post(this.props.properties.logicUrl + "/recommend", requestBody, getAxiosConfig())
                .then((response) => {
                    this.setState({
                        results: response.data.items,
                        raw: response.data.recommendationResponse,
                        time: response.data.took,
                        loadingResults: false,
                        noResultsFound: true
                    });

                    if (this.state.debugModeChecked) {
                        localStorage.setItem("debugInfo", JSON.stringify(response.data.additionalInfo));
                    }

                    this.props.onDebugRecomendationsGot();
                })
                .catch((err) => {
                    if (err.response) {
                        this.props.showToastForBackend(err.response.data);
                    } else {
                        this.props.showToastForFrontend(MessageCodes.CONNECTION_ERROR);
                    }
                    this.setState({
                        loadingResults: false
                    });
                });

        });
    }

    onDebugModeCheck() {
        if (this.state.debugModeChecked) {
            localStorage.removeItem("debugInfo");
            this.props.onDebugDisabled();
        }
        this.setState((prevState) => ({
            debugModeChecked: !prevState.debugModeChecked,
        }));
    }

    render() {
        return (
            <div className="test-logic-wrapper" onClick={(e) => this.handleGroundClick(e)}>
                <div className="test-logic">
                    <div className="header">
                        <h2 className="title">Recommendation Test</h2>

                        <div className="checkbox-title">
                            <input type="checkbox"
                                   name="Debug mode"
                                   className="checkbox"
                                   checked={this.state.debugModeChecked}
                                   onChange={this.onDebugModeCheck}/>
                            <label htmlFor="Debug mode">Debug mode</label>
                        </div>

                        <button className="action-button" onClick={this.onGetRecommendation}>
                            <span className="button-label">Recommend</span>
                            <i
                                className={"material-icons " + (this.state.loadingResults ? "animate" : "")}
                            >replay</i>
                        </button>
                    </div>
                    <div className="content">
                        <div className="options">
                            <div className="request-params">
                                <div className="request-params__header">
                                    <h3 className="sub-title">Request Parameters</h3>
                                    <button className="secondary-button">Reset parameters
                                        <MaterialIcon icon="close"/>
                                    </button>
                                </div>
                                <div className="request-params__input-list">
                                    {this.state.requestParamsFields.map((param, index) => <TestOptionInput {...param}
                                                                                                           key={index}
                                                                                                           handleValueChange={(name, value) => this.handleRequestParamChange(name, value)}/>)}

                                </div>
                            </div>
                            <div className="context-props">
                                <div className="context-props__header">
                                    <h3 className="sub-title">Context Properties</h3>
                                </div>
                                <div className="context-props__input-list">
                                    {this.state.contextPropsFields.map((param, index) => <TestOptionInput {...param}
                                                                                                          key={index}
                                                                                                          blue={true}
                                                                                                          contextProp={true}
                                                                                                          handleValueChange={(name, value) => this.handleContextPropChange(name, value)}/>)}
                                </div>
                            </div>
                        </div>
                        <RawPanel results={this.state.results} time={this.state.time} raw = {this.state.raw} isRequested={this.state.noResultsFound}/>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        properties: state.properties,
        contextProperties: state.contextProperties
    }
}

export default connect(mapStateToProps, {showToastForBackend, showToastForFrontend})(LogicTestingPanel);